// extracted by mini-css-extract-plugin
module.exports = {"root":"PatternAutocomplete_root__2VJ8c","list":"PatternAutocomplete_list__3P7XU"};